import { AppRouter } from './Router.js';

export function App() {
  return <AppRouter />;
}
